<template>
  <div>
    <el-row>
      <el-card style="margin: auto">
        <div slot="header" class="clearfix">
          <span style="float:left; font-weight: 800">域名列表</span>
          <el-button style="float:right" size="small" type="text" @click="show_add">添加新域名</el-button>
        </div>

        <el-dialog :visible.sync="visible" title="新建域名" width="30%">
          <el-form ref="zone" :model="zone" :rules="zone_rules" label-width="80px">
            <el-form-item prop="zoneName" label="域名">
              <el-input v-model="zone.zoneName" placeholder="请输入域名"></el-input>
            </el-form-item>
            <el-form-item prop="managerBy" label="管理方">
              <el-select v-model="zone.managerBy" placeholder="请选择管理方" style="display:block;">
                <el-option v-for="i in manager" :key="i" :value="i" :label="i"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button size="small">取消</el-button>
            <el-button size="small" type="primary" @click="create_zone">创建</el-button>
          </template>
        </el-dialog>

        <el-table :data="zones" border>
          <el-table-column label="ID" prop="id" width="100"></el-table-column>
          <el-table-column label="域名" prop="zoneName"></el-table-column>
          <el-table-column label="管理方" prop="managerBy"></el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="delete_zone(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog
          :visible.sync="edit_visible"
          :title="'修改' + this.zone.zoneName + '信息'"
          width="30%"
        >
          <el-form ref="zone" :model="zone">
            <el-form-item prop="managerBy" label="管理方">
              <el-select v-model="zone.managerBy" placeholder="请选择管理方" style="display:block;">
                <el-option v-for="i in manager" :key="i" :value="i" :label="i"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // manager: ["aliyun", "aws"],
      manager: ["aliyun"],
      zone: {
        zoneName: "",
        managerBy: "",
      },
      visible: false,
      edit_visible: false,
      zones: [],
      record_types: ["A", "CNAME"],
      records: [],
      zone_rules: {
        zoneName: [{ required: true, message: "请输入域名", trigger: "blur" }],
        managerBy: [
          { required: true, message: "请输入管理方", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.get_zones();
  },
  methods: {
    get_zones() {
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/dnszones?currentPage=0&pageSize=20", {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取规则列表失败: " + res.data.message,
              type: "error",
            });
          } else {
            _this.zones = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "获取域名列表失败: " + err.toString(),
            type: "error",
          });
        });
    },
    edit_zone_manager(value) {
      this.zone.managerBy = value;
    },
    create_zone() {
      const _this = this;
      console.log(_this.zone);
      _this.$refs["zone"].validate((valid) => {
        if (valid) {
          console.log("new zone: ", _this.zone);
          _this.$axios
            .post(_this.config.path + "/dnszones", _this.zone, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "创建域名失败: " + res.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "创建域名成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 500);
              }
            })
            .catch(function (err) {
              _this.$message({
                showClose: true,
                message: "创建域名失败: " + err.toString(),
                type: "error",
              });
            });
        }
      });
    },
    delete_zone(id) {
      console.log("delete zone id: ", id);
      const _this = this;
      _this
        .$confirm("删除域名后无法还原，确认删除么？", "删除域名", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
        .then(() => {
          _this.$axios
            .delete(_this.config.path + "/dnszones/" + id, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "删除域名失败: " + res.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "删除域名成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 500);
              }
            })
            .catch(function (err) {
              _this.$message({
                type: "error",
                message: "删除域名失败: " + err.toString(),
                showClose: true,
              });
            });
        })
        .catch(() => {
          _this.$message({
            showClose: true,
            message: "已取消删除",
            type: "info",
          });
        });
    },
    show_add() {
      this.record = {
        recordName: "",
        type: "A",
        recordValue: "",
        ttl: 600,
        author: "",
        zone: "",
        env: "test",
      };
      this.visible = true;
    },
  },
};
</script>

<style>
.editable-btn {
  margin: 8px;
}
</style>
